module.exports = __webpack_public_path__ + "static/logistics-collect-goods-39bc5728dc2f37011eefb140e79fdacd.png";